<template>
    <a-spin :spinning="busy" :delay="200" class="tab-general" style="width: 100%">
        <div class="tab-general md:mt-0" v-if="hasElements">
            <div class="vx-row" >
                
                <slot />

            </div>
        </div>
        <div v-else>
            {{ noElementsText }}
        </div>
    </a-spin>
</template>

<script>
import { mapState } from 'vuex'
    export default {
        props: {
            hasElements: [Boolean, Number],
            noElementsText: {
                type: String,
                default: 'Nada pendente!'
            }
        },
        computed: mapState('fiscal', ['busy'])
    }
</script>
